var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForwardArrowinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.207 8.37a1 1 0 000-1.414L14.843.592a1 1 0 10-1.414 1.414l5.657 5.657-5.657 5.657a1 1 0 001.414 1.414l6.364-6.364zM.5 8.663h20v-2H.5v2z",
    fill: "#fff"
  })));
}
export default SvgForwardArrowinline;